export function minDigitsLength(value, input, count) {
    const digitCount = value.replace(/\D+/g, '').length

    return digitCount >= count
}

export function maxDigitsLength(value, input, count) {
    const digitCount = value.replace(/\D+/g, '').length

    return digitCount <= count
}

export function isEmail(value) {
    // eslint-disable-next-line max-len, no-useless-escape
    const regex =
        // eslint-disable-next-line max-len, no-useless-escape
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

    return regex.test(value)
}
export function isNumber(value) {
    // eslint-disable-next-line no-useless-escape
    const regex = /^[\d\-\+\(\)\s]+$/

    return regex.test(value)
}

export function isTextFieldNotEmpty(value) {
    return value.trim().length > 0
}

export function isSumm(value, num1, num2) {
    return value == num1 + num2
}
